"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Microphone = function Microphone(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "MicrophoneTitle MicrophoneDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "MicrophoneTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "MicrophoneDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(7 2)",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M8.806 21.18c-3.567 0-6.503-2.935-6.503-6.503V6.774C2.303 3.206 5.24.271 8.806.271c3.568 0 6.504 2.935 6.504 6.503v7.903c0 3.568-2.936 6.504-6.504 6.504zm0-20.006c-3.07 0-5.6 2.53-5.6 5.6v7.903c0 3.071 2.53 5.6 5.6 5.6 3.071 0 5.6-2.529 5.6-5.6V6.774c0-3.07-2.529-5.6-5.6-5.6z",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M8.806 27.684c-.27 0-.451-.18-.451-.452v-4.47c0-.272.18-.452.451-.452s.452.18.452.451v4.471c0 .226-.18.452-.452.452zM5.826 8.265H2.755c-.271 0-.452-.181-.452-.452s.18-.452.452-.452h3.07c.272 0 .452.18.452.452a.453.453 0 0 1-.451.452zm0 2.709H2.755c-.271 0-.452-.18-.452-.451s.18-.452.452-.452h3.07c.272 0 .452.18.452.452a.453.453 0 0 1-.451.451zm0 3.432H2.755c-.271 0-.452-.18-.452-.451s.18-.452.452-.452h3.07c.272 0 .452.18.452.452a.453.453 0 0 1-.451.451zm9.032-6.141h-3.07c-.272 0-.453-.181-.453-.452s.181-.452.452-.452h3.071c.271 0 .452.18.452.452 0 .27-.181.452-.452.452zm0 2.709h-3.07c-.272 0-.453-.18-.453-.451s.181-.452.452-.452h3.071c.271 0 .452.18.452.452 0 .27-.181.451-.452.451zm0 3.432h-3.07c-.272 0-.453-.18-.453-.451s.181-.452.452-.452h3.071c.271 0 .452.18.452.452 0 .27-.181.451-.452.451z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M8.806 23.168c-4.606 0-8.4-3.749-8.4-8.4v-2.123c0-.27.181-.451.452-.451s.452.18.452.451v2.123c0 4.11 3.342 7.497 7.496 7.497a7.478 7.478 0 0 0 7.497-7.497v-2.123c0-.27.18-.451.452-.451.27 0 .451.18.451.451v2.123c0 4.651-3.793 8.4-8.4 8.4zm7.723 4.516H1.716c-.27 0-.451-.18-.451-.452 0-.27.18-.451.451-.451h14.858c.271 0 .452.18.452.451s-.226.452-.497.452z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "8.897",
    cy: "5.148",
    r: "1"
  })));
};

Microphone.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Microphone.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Microphone;
exports["default"] = _default;